<template>
    <v-app id="psi">
        <keep-alive>
            <component
                v-if="$route.meta.layout"
                :is="`${$route.meta.layout}-layout`"
            ></component>
        </keep-alive>
    </v-app>
</template>

<script>
export default {
    name: "App",
    components: {
        AuthLayout: () => import("./layouts/auth/AuthLayout"),
        PrintLayout: () => import("./layouts/print/PrintLayout"),
        PublicLayout: () => import("./layouts/public/PublicLayout"),
    },
    data: () => ({}),
    computed: {},
    mounted() {},
    created() {},
};
</script>

<style>
</style>

